import axios from "../../lib/axiosInstance";

export const fetchAllClients = async (payload = {}) => {
  const queryParams = new URLSearchParams();
  if (payload.page) queryParams.append("page", payload.page);
  if (payload.limit) queryParams.append("limit", payload.limit);

  if (payload.search?.trim()) queryParams.append("search", payload.search.trim());
  if (payload.manager?.trim()) queryParams.append("manager", payload.manager.trim());
  if (payload.clientId) queryParams.append("clientId", payload.clientId);
  if (Array.isArray(payload.teamIds) && payload.teamIds.length > 0) {
    queryParams.append("teamIds", payload.teamIds.join(","));
  } else if (typeof payload.teamIds === "string") {
    queryParams.append("teamIds", payload.teamIds);
  }
  if (payload.country) queryParams.append("country", payload.country);

  if (payload.branchId) queryParams.append("branchId", payload.branchId);
  if (payload.teamId) queryParams.append("teamId", payload.teamId);

  if (payload.taxType) queryParams.append("taxType", payload.taxType);

  if (payload.projectsCount || payload.projectsCount === 0)
    queryParams.append("projectsCount", payload.projectsCount);
  if (payload.totalWorkOrdersCount || payload.totalWorkOrdersCount === 0)
    queryParams.append("totalWorkOrdersCount", payload.totalWorkOrdersCount);
  if (payload.publishedCount || payload.publishedCount === 0)
    queryParams.append("publishedCount", payload.publishedCount);
  if (payload.assignedCount || payload.assignedCount === 0)
    queryParams.append("assignedCount", payload.assignedCount);
  if (payload.workDoneCount || payload.workDoneCount === 0)
    queryParams.append("workDoneCount", payload.workDoneCount);
  if (payload.approvedCount || payload.approvedCount === 0)
    queryParams.append("approvedCount", payload.approvedCount);
  if (payload.paidCount || payload.paidCount === 0)
    queryParams.append("paidCount", payload.paidCount);

  if (payload.isParentClient !== undefined && payload.isParentClient !== "")
    queryParams.append("isParentClient", payload.isParentClient);

  if (payload.parentClientId) queryParams.append("parentClientId", payload.parentClientId);

  const url = `clients${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
  const response = await axios.get(url);
  return response.data;
};

export function createClient(payload) {
  return axios.post("clients", payload).then((res) => res.data);
}

export function createCustomerUser({ id, data }) {
  return axios.post(`clients/owner/${id}`, data).then((res) => res.data);
}

export function deleteCustomerUser(clientId) {
  return axios.delete(`clients/owner/${clientId}`).then((res) => res.data);
}
export function getClientById(clientId) {
  return axios.get(`clients/${clientId}`).then((res) => res.data);
}

export function updateClient({ id, formData }) {
  return axios.patch(`clients/${id}`, formData).then((res) => res.data);
}
export function updateOwnCustomerProfile(formData) {
  return axios.patch("clients/customer/profile", formData).then((res) => res.data);
}

export function updateCustomerProfileAsAdmin({ id, formData }) {
  return axios.patch(`clients/${id}/customerProfile`, formData).then((res) => res.data);
}

// A customer owner adds an entity under their own account (multipart: logo and certificate).
export function createOwnEntity(formData) {
  return axios.post("clients/customer/entities", formData).then((res) => res.data);
}

// A customer owner edits one of their own entities (multipart: certificate).
export function updateOwnEntity({ id, formData }) {
  return axios.patch(`clients/customer/entities/${id}`, formData).then((res) => res.data);
}

export function submitCustomerProfile() {
  return axios.get("clients/customer/submitProfile").then((res) => res.data);
}

export function deleteClient(clientId) {
  return axios.delete(`clients/${clientId}`).then((res) => res.data);
}

export function getClientAccountById(clientId, byClientId = false) {
  return axios
    .get(`clients/account/${clientId}`, {
      params: { byClientId },
    })
    .then((res) => res.data);
}

export function createClientAccount(payload) {
  return axios.post(`clients/account`, payload).then((res) => res.data);
}
export function fetchAllClientAccounts(payload) {
  return axios.get(`clients/accounts`, payload).then((res) => res.data);
}

export function updateClientAccount({ id, payload }) {
  return axios.patch(`clients/account/${id}`, payload).then((res) => res.data);
}

export const fetchChildClients = async (parentClientId, payload = {}) => {
  const queryParams = new URLSearchParams();
  if (payload.page) queryParams.append("page", payload.page);
  if (payload.limit) queryParams.append("limit", payload.limit);
  if (payload.search?.trim()) queryParams.append("search", payload.search.trim());
  if (payload.clientId) queryParams.append("clientId", payload.clientId);
  if (payload.branchId) queryParams.append("branchId", payload.branchId);
  if (payload.teamIds?.length) queryParams.append("teamIds", payload.teamIds.join(","));
  if (payload.manager?.trim()) queryParams.append("manager", payload.manager.trim());
  if (payload.country?.trim()) queryParams.append("country", payload.country.trim());
  if (payload.taxType) queryParams.append("taxType", payload.taxType);
  const url = `clients/${parentClientId}/children${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
  const response = await axios.get(url);
  return response.data;
};

export const fetchAvailableToLinkClients = async ({ page = 1, limit = 20 } = {}) => {
  const response = await axios.get("clients/availableToLink", { params: { page, limit } });
  return response.data;
};

export const linkClientToParent = async (childIds, parentClientId) => {
  const response = await axios.patch(`clients/linkToParent`, { childIds, parentClientId });
  return response.data;
};

export const unlinkClientFromParent = async (childId) => {
  const response = await axios.patch(`clients/unlinkFromParent`, { childId });
  return response.data;
};
